import axios from '@/services/axios'

const fetchStandsData = async (
	data: FilterPayload,
): Promise<{ data: Stand[]; pagination: Pagination }> => {
	const queryParams = new URLSearchParams()
	queryParams.append('page', data.pageNumber)
	queryParams.append('limit', data.pageSize)

	if (data.filterColumn && data.filterValue) {
		queryParams.append('filterColumn', data.filterColumn)
		queryParams.append('filterValue', data.filterValue)
	}

	const queryString = queryParams.toString()

	const response = await axios.get(`/stand/all?${queryString}`)
	return response.data
}

const fetchStandById = async (standId: Stand['id']): Promise<Stand> => {
	const response = await axios.get(`/stand/${standId}`)
	return response.data?.data
}

const fetchStandStatus = async (startDate: Date, endDate: Date): Promise<StandStatus[]> => {
	const response = await axios.get(
		`/stand/stand_status_by_dates?startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
	)
	return response.data.data
}

const fetchUsersForSelectedStand = async (standId: Stand['id']): Promise<number[]> => {
	const response = await axios.get(`/product/get-stand-users/${standId}`)
	return response.data.data
}

const fetchStandsForSelectedUser = async (userId: User['id']): Promise<number[]> => {
	const response = await axios.get(`/product/get-users-stands/${userId}`)
	return response.data.data
}

const archiveProduct = async (data: { standId: string[]; userId: string }) => {
	const response = await axios.post('/product/archive', data)
	return response.data
}

const archiveProductByBookingId = async (data: { bookingId: string }) => {
	const response = await axios.post('/product/archive', data)
	return response.data
}

const updateStand = async (id: number, status: 'Disabled' | 'active') => {
	const response = await axios.put(`/stand/${id}`, { status })
	return response.data
}

const lockStand = async (stand_id: Stand['id'], start: string, end: string) => {
	const response = await axios.post('/reservations/lock-stand', { stand_id, start, end })
	return response.data
}

const verifyStandAvailability = async (standId: Stand['id'], startDate: Date, endDate: Date) => {
	const response = await axios.get(
		`/stand/verify_stand_availability?standId=${standId}&startDate=${startDate.toISOString()}&endDate=${endDate.toISOString()}`,
	)
	return response.data.data
}

const standService = {
	archiveProduct,
	archiveProductByBookingId,
	fetchStandsData,
	fetchStandStatus,
	fetchStandById,
	lockStand,
	updateStand,
	fetchUsersForSelectedStand,
	fetchStandsForSelectedUser,
	verifyStandAvailability,
}

export default standService
